module.exports = __webpack_public_path__ + "static/img/99053D_2_C_20200404_LC.4cec647.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/99053D_2_C_20200404_LC.png
// module id = 6/9Q
// module chunks = 0